// Shared pagination / fetch-size constants.
// Use these instead of re-declaring page sizes inline in list/table components.

export const DEFAULT_PAGE_SIZE = 25;
export const SMALL_PAGE_SIZE = 10;

// Used when a screen needs the full dataset for client-side filtering.
export const BULK_FETCH_LIMIT = 1000;

// Ant Design Table pageSizeOptions for standard list tables.
export const TABLE_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

// Card-grid layouts (Screen/Workflow lists) page through fewer items.
export const CARD_PAGE_SIZE_OPTIONS = [12, 25, 50];
